/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Origin_Story_BioInputs */

const en_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator Origin Story (Bio)`)
};

const es_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia de origen del creador (Bio)`)
};

const fr_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histoire du créateur (Bio)`)
};

const de_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ursprungsgeschichte des Creators (Bio)`)
};

const ja_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイターのオリジンストーリー (自己紹介)`)
};

const zh_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作者起源故事 (简介)`)
};

const ar_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قصة منشئ المحتوى (السيرة الذاتية)`)
};

const id_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kisah Asal Kreator (Bio)`)
};

const it_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storia delle Origini del Creatore (Bio)`)
};

const ru_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`История создателя (Биография)`)
};

const pt_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`História de Origem do Criador (Biografia)`)
};

const ko_creator_origin_story_bio = /** @type {(inputs: Creator_Origin_Story_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이터 스토리 (소개)`)
};

/**
* | output |
* | --- |
* | "Creator Origin Story (Bio)" |
*
* @param {Creator_Origin_Story_BioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const creator_origin_story_bio = /** @type {((inputs?: Creator_Origin_Story_BioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Origin_Story_BioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creator_origin_story_bio(inputs)
	if (locale === "es") return es_creator_origin_story_bio(inputs)
	if (locale === "fr") return fr_creator_origin_story_bio(inputs)
	if (locale === "de") return de_creator_origin_story_bio(inputs)
	if (locale === "ja") return ja_creator_origin_story_bio(inputs)
	if (locale === "zh") return zh_creator_origin_story_bio(inputs)
	if (locale === "ar") return ar_creator_origin_story_bio(inputs)
	if (locale === "id") return id_creator_origin_story_bio(inputs)
	if (locale === "it") return it_creator_origin_story_bio(inputs)
	if (locale === "ru") return ru_creator_origin_story_bio(inputs)
	if (locale === "pt") return pt_creator_origin_story_bio(inputs)
	return ko_creator_origin_story_bio(inputs)
});